import { render, staticRenderFns } from "./edit-zhuanbing-scale.vue?vue&type=template&id=6e83bf1c&scoped=true&"
import script from "./edit-zhuanbing-scale.vue?vue&type=script&lang=ts&"
export * from "./edit-zhuanbing-scale.vue?vue&type=script&lang=ts&"
import style0 from "./edit-zhuanbing-scale.vue?vue&type=style&index=0&id=6e83bf1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e83bf1c",
  null
  
)

export default component.exports